import { mapActions, mapGetters } from "vuex";

import moment from "moment";
import { VueSlideToggle } from "vue-slide-toggle";

export default {
    name: "active-order",
    props: ["item"],
    data() {
        return {
            openitemInfo: false,
        };
    },
    components: {
        VueSlideToggle,
    },
    computed: {
        ...mapGetters({}),
    },
    created() {},
    methods: {
        ...mapActions({}),
        formatDate(date) {
            return moment(date).format("YYYY-MM-DD");
        },
    },
};
